import i18n from 'i18next';

/**
 * Get the native-language title from a JSONB titles object.
 * Returns undefined if the user's language is English, titles is null/empty, or no match found.
 *
 * Match strategy: exact → base language fallback ("zh-TW" → "zh") → prefix match ("zh" → "zh-CN")
 */
export function getNativeTitle(
  titles: Record<string, string> | null | undefined,
  language?: string,
): string | undefined {
  const lang = language || i18n.language;

  // Don't show native title if user language is English
  if (!lang || lang === 'en' || lang.startsWith('en-')) return undefined;
  if (!titles || typeof titles !== 'object') return undefined;

  // Exact match
  if (titles[lang]) return titles[lang];

  // Base language fallback: "zh-TW" → "zh"
  const baseLang = lang.split('-')[0];
  if (titles[baseLang]) return titles[baseLang];

  // Prefix match: "zh" → first key starting with "zh-"
  const prefixMatch = Object.keys(titles).find(
    (key) => key.startsWith(baseLang + '-') || key.split('-')[0] === baseLang,
  );
  if (prefixMatch) return titles[prefixMatch];

  return undefined;
}
